import React, { useContext, useEffect, useRef, useState } from 'react';
import styles from '../GuidanceCard.scss';
import Icon from '@xo-union/tk-component-icons';
import { Tooltip, TooltipContainer } from '@xo-union/tk-component-tooltips';
import { websiteSettingsRoute } from '../../../../helpers/routes';
import { Link } from 'react-router-dom';
import { TrackingContext } from '../../../../TrackingContext';
import OutsideClickHandler from '@xo-union/component-outside-click';

const ACTION_NAME_FOR_TOOLTIP_IMPRESSION = 'view tracker tooltip';
const CounterHeader = () => {
  const { fireOnce, track } = useContext(TrackingContext);

  const iconRef = useRef<HTMLDivElement>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);

  const [tooltipVisible, setTooltipVisible] = useState(false);

  const toggleTooltipVisibility = () => setTooltipVisible(!tooltipVisible);
  const openTooltip = () => {
    setTooltipVisible(true);
  };
  const closeTooltip = () => setTooltipVisible(false);

  useEffect(() => {
    const { current } = iconRef;
    if (current) {
      // On hover of the tooltip icon - open the tooltip
      current.addEventListener('mouseenter', openTooltip);
    }
    return () => {
      if (current) {
        current.removeEventListener('mouseenter', openTooltip);
      }
    };
  }, [iconRef]);

  useEffect(() => {
    const { current } = tooltipRef;
    if (current) {
      // On hover out of the tooltip - close the tooltip
      current.addEventListener('mouseleave', closeTooltip);
    }
    return () => {
      if (current) {
        current.removeEventListener('mouseleave', closeTooltip);
      }
    };
  }, [tooltipRef, tooltipVisible]);

  useEffect(() => {
    if (tooltipVisible) {
      fireOnce(ACTION_NAME_FOR_TOOLTIP_IMPRESSION, () =>
        track('WWS Dashboard Interaction', {
          action: 'view tooltip',
          actionName: ACTION_NAME_FOR_TOOLTIP_IMPRESSION,
        })
      );
    }
  }, [tooltipVisible, fireOnce, track]);

  const onClickLink = () => {
    closeTooltip();
    track('WWS Dashboard Interaction', {
      action: 'click tooltip link',
      actionName: 'Privacy Settings',
      selection: 'set a password > privacy settings',
    });
  };

  return (
    <div className={styles.title}>
      <div className={`${styles.titleText} ${styles.viewTrackerTitle}`}>Unique visitors</div>
      <OutsideClickHandler onOutsideClick={closeTooltip}>
        <TooltipContainer className={styles.tooltipContainer}>
          <div
            className={styles.tooltipTarget}
            data-testid="view-tracker-tooltip-target"
            ref={iconRef}
            onClick={toggleTooltipVisibility}
            onKeyPress={toggleTooltipVisibility}
          >
            <Icon name="info" size="sm" />
          </div>

          {tooltipVisible && (
            <div
              className={styles.tooltipWrapper}
              ref={tooltipRef}
              id="view-tracker-tooltip-wrapper"
              data-testid="view-tracker-tooltip-wrapper"
            >
              <Tooltip
                className={styles.tooltip}
                role="alert"
                id="view-tracker-tooltip"
                data-testid="view-tracker-tooltip"
              >
                {`See how many different people visited your website in the past 7 days and overall. `}
                <Link to={websiteSettingsRoute} onClick={onClickLink}>
                  Set a password
                </Link>
                {` to make your site private.`}
              </Tooltip>
            </div>
          )}
        </TooltipContainer>
      </OutsideClickHandler>
    </div>
  );
};

export default CounterHeader;
